import React, { useEffect, useState } from 'react'
import request from '../../../Helpers/API';

import { useHistory } from "react-router-dom";

import Swal from 'sweetalert2';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import { Button, MenuItem, TextField } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//import ModalAgregarLineasScorecard from './ModalAgregarLineasScorecard';

import { LoaderScreen } from '../../components/LoaderScreen';
import { FormatMoney } from '../../../Helpers/FormatNumber';


export const PrecioLineaMainScreen = () => {
    const history = useHistory();
    const [data, setData] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [nuevosDatos, setNuevosDatos] = useState([]);

    const [ejercicio, setEjercicio] = useState(0);
    const [sucursal, setSucursal] = useState(1);



    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    const [idlinea, setIdlinea] = useState(0)

    const year = new Date().getFullYear();

    // Crear array con los 3 años: actual, actual -1, actual -2
    const opcionesEjercicio = [
        year,
        year - 1,
        year - 2
    ];

    const onHome = () => {
        history.push("/Ventas/Main")
    };



    useEffect(() => {
        const anioActual = new Date().getFullYear();
        setEjercicio(anioActual)

        onCargarLista(anioActual, sucursal)
    }, []);

    const onCargarLista = (ejercicio, sucursal) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`PrecioLineas/Listado?ejercicio=${ejercicio}&sucursal=${sucursal}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result)

            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("LISTADO MENU", JSON.stringify(error), "error");
            });
    }

    const meses = {
        enero: 1,
        febrero: 2,
        marzo: 3,
        abril: 4,
        mayo: 5,
        junio: 6,
        julio: 7,
        agosto: 8,
        septiembre: 9,
        octubre: 10,
        noviembre: 11,
        diciembre: 12
    };

    const handleChange = (event, index, mes) => {
        const nuevoValor = event.target.value;

        setData(prevData => {
            const newData = [...prevData];
            newData[index][mes] = nuevoValor;
            return newData;
        });

        setNuevosDatos(prev => {
            const item = data[index];
            const periodo = meses[mes];

            const nuevoRegistro = {
                idlinea: item.idlinea,
                sucursal: item.sucursal || 1,       // usa el valor por defecto si no está
                ejercicio: item.ejercicio || 2025,  // usa el valor por defecto si no está
                periodo: periodo,
                precio: parseFloat(nuevoValor) || 0
            };

            // Ver si ya existe un cambio para este registro
            const existe = prev.find(p =>
                p.idlinea === nuevoRegistro.idlinea &&
                p.periodo === nuevoRegistro.periodo &&
                p.sucursal === nuevoRegistro.sucursal &&
                p.ejercicio === nuevoRegistro.ejercicio
            );

            if (existe) {
                // Reemplaza el valor existente
                return prev.map(p =>
                    p.idlinea === nuevoRegistro.idlinea &&
                        p.periodo === nuevoRegistro.periodo &&
                        p.sucursal === nuevoRegistro.sucursal &&
                        p.ejercicio === nuevoRegistro.ejercicio
                        ? nuevoRegistro
                        : p
                );
            } else {
                // Agrega nuevo cambio
                return [...prev, nuevoRegistro];
            }
        });
    };

    const onGuardar = () => {
        setLoader({ ...loader, mostrar: true });

        if (nuevosDatos.length === 0) {
            alert("No hay cambios para guardar.");
            return;
        }

        const mdl = {
            preciosLinea: nuevosDatos
        }
        request
            .post(`PrecioLineas`, mdl)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                // setData(result)
                onCargarLista(ejercicio, sucursal)
                setNuevosDatos([])

                Swal.fire(
                    "PROYECCION POR LINEA",
                    "Poyecciones registradas con exito",
                    "success"
                );
            })
            .catch((error) => {
                console.log(error);
                setLoader({ ...loader, mostrar: false });
            });
    };

    console.log(nuevosDatos)

    return (
        <PlantillaScreen
            titulo={"IMPORTE PROYECTADO POR LINEA"}
            className_main={1}
            className={"lineas-scorecard-main-screen"}
        >
            <LoaderScreen loader={loader} />
            <div>
                <div className='precio-lineas-encabezado'>
                    <div className='lineas-scorecard-container'>
                        <div className="lineas-scorecard-listado-Container">
                            <div className='precio-linea-filtro-container'>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Ejercicio"
                                    variant="outlined"
                                    className="cel-1"
                                    select
                                    type="text"
                                    onChange={({ target }) => {
                                        setEjercicio(target.value);
                                    }}
                                    value={ejercicio}
                                >
                                    {opcionesEjercicio.map((anio) => (
                                        <MenuItem key={anio} value={anio.toString()}>
                                            {anio}
                                        </MenuItem>
                                    ))}
                                </TextField>


                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Sucursal"
                                    variant="outlined"
                                    className="cel-2"
                                    select
                                    type="text"
                                    onChange={({ target }) => {
                                        setSucursal(target.value);
                                    }}
                                    value={sucursal}
                                >
                                    <MenuItem value={"1"}>NAVOLATO</MenuItem>
                                    <MenuItem value={"2"}>TEPIC</MenuItem>
                                    <MenuItem value={"11"}>CAIMANERO</MenuItem>
                                    <MenuItem value={"12"}>SAN JOSE</MenuItem>
                                    <MenuItem value={"21"}>ELDORADO</MenuItem>
                                    <MenuItem value={"22"}>SANTIAGO I.</MenuItem>
                                    <MenuItem value={"31"}>COSTA RICA</MenuItem>
                                    <MenuItem value={"32"}>TECUALA</MenuItem>
                                    <MenuItem value={"41"}>LA CRUZ</MenuItem>
                                    <MenuItem value={"51"}>EL ROSARIO</MenuItem>
                                    <MenuItem value={"52"}>SAN VICENTE</MenuItem>
                                    <MenuItem value={"61"}>VILLA UNION</MenuItem>
                                </TextField>

                                <Button
                                    variant="contained"
                                    className='lineas-scorecard-agregar-nueva-linea'
                                    onClick={() => onCargarLista(ejercicio, sucursal)}
                                >
                                    Buscar
                                </Button>
                            </div>
                            <div className='scorecard-vendedor-tabla scroll-4'>
                                <table cellPadding={0} cellSpacing={0}>
                                    <thead>
                                        <tr>
                                            <th>ID Línea</th>
                                            <th>
                                                <div>Línea</div>
                                            </th>
                                            <th>
                                                <div>Enero</div>
                                            </th>
                                            <th>
                                                <div>Febrero</div>
                                            </th>
                                            <th>
                                                <div>Marzo</div>
                                            </th>
                                            <th>
                                                <div>Abril</div>
                                            </th>
                                            <th>
                                                <div>Mayo</div>
                                            </th>
                                            <th>
                                                <div>Junio</div>
                                            </th>
                                            <th>
                                                <div>Julio</div>
                                            </th>
                                            <th>
                                                <div>Agosto</div>
                                            </th>
                                            <th>
                                                <div>Septiembre</div>
                                            </th>
                                            <th>
                                                <div>Octubre</div>
                                            </th>
                                            <th>
                                                <div>Noviembre</div>
                                            </th>
                                            <th>
                                                <div>Diciembre</div>
                                            </th>
                                            {/* <th>
                                                <div>Total</div>
                                            </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item, index) => {
                                            // Calcula la suma de la fila
                                            const total = [
                                                item.enero,
                                                item.febrero,
                                                item.marzo,
                                                item.abril,
                                                item.mayo,
                                                item.junio,
                                                item.julio,
                                                item.agosto,
                                                item.septiembre,
                                                item.octubre,
                                                item.noviembre,
                                                item.diciembre
                                            ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0); // Asegura que se sumen solo números

                                            return (
                                                <tr key={index}>
                                                    <td className='columna-centrada'>{item.idlinea}</td>
                                                    <td>{item.linea}</td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 1}><input type="text" value={item.enero}
                                                        onChange={(event) => handleChange(event, index, "enero")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 2}><input type="text" value={item.febrero}
                                                        onChange={(event) => handleChange(event, index, "febrero")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 3}><input type="text" value={item.marzo}
                                                        onChange={(event) => handleChange(event, index, "marzo")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 4}><input type="text" value={item.abril}
                                                        onChange={(event) => handleChange(event, index, "abril")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 5}><input type="text" value={item.mayo}
                                                        onChange={(event) => handleChange(event, index, "mayo")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 6}><input type="text" value={item.junio}
                                                        onChange={(event) => handleChange(event, index, "junio")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 7}><input type="text" value={item.julio}
                                                        onChange={(event) => handleChange(event, index, "julio")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 8}><input type="text" value={item.agosto}
                                                        onChange={(event) => handleChange(event, index, "agosto")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 9}><input type="text" value={item.septiembre}
                                                        onChange={(event) => handleChange(event, index, "septiembre")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 10}><input type="text" value={item.octubre}
                                                        onChange={(event) => handleChange(event, index, "octubre")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)} 
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 11}><input type="text" value={item.noviembre}
                                                        onChange={(event) => handleChange(event, index, "noviembre")}
                                                    // onKeyDown={(event) => onKeyDown(event, index)}
                                                    /></td>
                                                    <td className='columna-centrada' tabIndex={index * 14 + 12}><input type="text" value={item.diciembre}
                                                        onChange={(event) => handleChange(event, index, "diciembre")}
                                                    // onKeyDown={(event) => onKeyDown2(event, index)} 
                                                    /></td>
                                                    {/* Nueva celda de Total */}
                                                    {/* <td className='columna-centrada total'>{FormatMoney(total)}</td> */}
                                                </tr>
                                            );
                                        })}
                                        {/* <tr>
                                            <td colSpan={2} className='columna-derecha total'>TOTALES: </td>
                                            {['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'].map((mes) => {
                                                const totalMes = data.reduce((acc, item) => acc + (parseFloat(item[mes]) || 0), 0);
                                                return <td key={mes} className='columna-centrada total'>{FormatMoney(totalMes)}</td>;
                                            })}
                                            <td className='columna-centrada total'>
                                                {data.reduce((acc, item) => acc + (parseFloat(item.enero) || 0) + (parseFloat(item.febrero) || 0) + (parseFloat(item.marzo) || 0) + (parseFloat(item.abril) || 0) + (parseFloat(item.mayo) || 0) + (parseFloat(item.junio) || 0) + (parseFloat(item.julio) || 0) + (parseFloat(item.agosto) || 0) + (parseFloat(item.septiembre) || 0) + (parseFloat(item.octubre) || 0) + (parseFloat(item.noviembre) || 0) + (parseFloat(item.diciembre) || 0), 0)}
                                            </td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='lineas-scorecard-boton-agregar-container'>
                            {
                                nuevosDatos.length > 0 && (
                                    <Button
                                        variant="contained"
                                        className='lineas-scorecard-agregar-nueva-linea'
                                        // onClick={handleOpenModal}
                                        // onClick={() => onAgregar()}
                                        onClick={() => onGuardar()}
                                    >
                                        {/* <PersonIcon /> */}
                                        Guardar
                                    </Button>
                                )
                            }

                        </div>
                    </div>

                    {/* <ModalAgregarLineasScorecard open={openModal} handleCloseModal={handleCloseModal} idlinea={idlinea} /> */}
                </div>
                <div>
                    <div className='home'
                        onClick={() => onHome()}
                    >
                        <ArrowBackIcon /> Regresar
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    )
}

